module.exports = async function fetchAnonymousContent(
	url,
	method = "GET",
	body = null,
	headers = null,
	agent = null,
	returnResponse = false
) {
	const isFormData = body instanceof FormData;
	if (body && !isFormData && !(body instanceof File)) {
		body = JSON.stringify(body);
	}
	var init = {
		method: method,
		headers: {},
	};
	if (!isFormData) {
		init.headers["Content-Type"] = "application/vnd.api+json";
	}
	if (agent) {
		init.agent = agent;
	}
	Object.assign(init.headers, headers);
	if (body) {
		init.body = body;
	}

	if (returnResponse) {
		const fetchResponse = await fetch(url, init)
			.then((response) => {
				return response;
			})
			.catch(function (err) {
				console.error(err.message);
			});
		return fetchResponse;
	} else {
		try {
			return await fetch(url, init)
				.then((response) => {
					if (response.ok) {
						return response.json();
					} else {
						console.error(response.status + "  " + url);
						throw new Error(
							`[01] Error: ${response.status} ${response.statusText} ${url}`
						);
					}
				})
				.then((response) => {
					if (response && !response.error) {
						return response;
					} else {
						let err_msg = response && response.error ? response.error : "Error";
						throw new Error("[02] " + err_msg);
					}
				})
				.catch(function (err) {
					console.error(err);
					throw new Error("[03] Error " + err.message);
				});
		} catch (error) {
			console.error(error.message);
			return { error: error.message };
		}
	}
};
